<template>
    <div class="mywarp">
        <img src="../images/share/vip_bg.png" class="myteam-bg">

        <div class="app-wrap">

            <div  class="item-vip dabiao" >
                <div class="vip">VIP0</div>
                <div class="bonus">Bônus</div>
                <div class="reward">R$0</div>
                <div class="bonus">Aposta válida</div>
                <div class="reward">R$0</div>
                <div class="bonus">Recompensas mensais</div>
                <div class="reward">R$0</div>
            </div>

            <div v-for="(item,index) in vip_list" :class="item.level>=level?'item-vip dabiao':'item-vip'" >
                <div class="vip">VIP{{item.level}}</div>
                <div class="bonus">Bônus</div>
                <div class="reward">R${{item.level_reward}}</div>
                <div class="bonus">Aposta válida</div>
                <div class="reward">R${{item.bet_amount}}</div>
                <div class="bonus">Recompensas mensais</div>
                <div class="reward">R${{item.month_reward}}</div>
            </div>


        </div>
        <ft></ft>
    </div>
</template>
<script>
import Fetch from "../../utils/fetch";
import ft from "../../components/ft.vue"
export default {
    name: 'app',
    data() {
        return {
            vip_list:[],
            level:0,
        };
    },
    mounted() {
        this.$parent.footer("user");
        //user/vip_config_list
        Fetch("/user/getUserInfoApi", {  }).then((r) => {
            this.level = r.data.leve;
            
        });
        Fetch("/user/vip_config_list", {  }).then((r) => {
          
            this.vip_list = r.data;
        });
    },
    components: {
        ft
    }
}


</script>
<style scoped>
.myteam-bg {
    width: 100%;
    height: 3.0rem;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
}
.dabiao{
    background-color: rgba(15, 197, 42, 0.9)!important;
}
.mywarp {
    height: auto;
    width: 100vw;
    background: url("../images/vip/sbg.png");
    padding-top: 1.3rem;
}

.app-wrap {
    width: 98%;
    margin: 20px auto;
    padding: 10px;
    display: flex;
    /* background: radial-gradient(#03cb50, transparent 86%); */
    margin-top: 20px;
    padding-bottom: 30px;
    flex-wrap: wrap;
    justify-content: space-between;
}

.item-vip {
    width: 46%;
    text-align: center;
    color: white;
    margin-bottom: 15px;
    background: url("../images/vip/vb.png") no-repeat;
    background-size: 100% 100%;
    padding: 0.5rem 5px;
    border-radius: 10px;
    display: block;
    padding-bottom: 0.2rem;

}

.vip {
    color: #fff;
    font-size: 0.35rem;
    margin: 4px auto;
    font-weight: 800;
    width: 60%;
    padding: 5px 0;
    background: url("../images/vip/vt.png") no-repeat;
    background-size: 100% 100%;
}

.bonus {
    font-size: 12px;
    margin-bottom: 10px;
}

.reward {
    color: #FFDF00;
    font-size: 18px;
    /* font-weight: 700; */
    margin-bottom: 10px;
}</style>